import styled from 'styled-components';
import { Route, Switch, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';

import { ProductsOverview } from './overview';
import { ProductCreate } from './create';
import { ProductInvoice } from "../components/ProductInvoice";

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class ProductsPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    // if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Switch>
          {/*<Route path="(.*)/products" component={ProductInvoice} />*/}
          <Route path="(.*)/products/create" component={ProductCreate} />
          <Route path="(.*)/products/:id(.*)" render={component => <ProductCreate id={component.match.params.id} />} />
          <Route component={ProductsOverview} />
        </Switch>
      </Container>
    );
  }
}

ProductsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductsPage = compose(withConnect, withRouter)(ProductsPageComp);
